import auth from '../../services/auth';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SET_DATA = 'LOGIN_SET_DATA';

export const login = (username, password) => async (dispatch) => {
  dispatch({ type: LOGIN });
  try {
    const payload = await auth.login(username, password);
    dispatch({ type: LOGIN_SUCCESS, payload });
  } catch (error) {
    const errorResponse = error.response;

    let errorCode;
    switch (errorResponse?.data?.error) {
      case 'INVALID_CREDENTIALS':
        errorCode = errorResponse?.data?.error;
        break;
      default:
        errorCode = 'UNKNOWN_ERROR';
    }

    dispatch({ type: LOGIN_ERROR, error: errorCode });
  }
};

export const setLoginData = (payload) => async (dispatch) => {
  dispatch({ type: LOGIN_SET_DATA, payload: payload });
};

export const logout = () => async (dispatch) => {
  auth.logout();
  dispatch({ type: LOGIN_SET_DATA, payload: null });
};
